import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import * as api from "@/services/cronJobsTracker";
import * as actions from "@/store/slices/cronJobsTracker.slice";
import { IApiResponse } from "@/services/cronJobsTracker/cronJobsTracker.types";

// Define action type
interface GetCronJobsTrackerDataAction extends PayloadAction<any> {
  type: typeof actions.getCronJobsTrackerData.type;
}
// Worker saga - Handles API request
function* getCronJobsTrackerDataSagaFunction(action: GetCronJobsTrackerDataAction): Generator {
  try {
    const response: any = yield call(api.fetchCronJobsTrackerData, action.payload);
    
    if (response?.data?.success) {
      yield put(actions.getCronJobsTrackerDataSuccess(response.data));
    } else {
      yield put(actions.getCronJobsTrackerDataFailure(response?.data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { 
      message: error?.message || "An unexpected error occurred" 
    };
    yield put(actions.getCronJobsTrackerDataFailure(errorData));
  }
}
// Watcher saga - Listens for dispatched actions
function* cronJobsTrackerSaga(): Generator {
  yield takeLatest(actions.getCronJobsTrackerData.type, getCronJobsTrackerDataSagaFunction);
}

export default cronJobsTrackerSaga;